import React, {useMemo} from "react";
import {
    Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip
} from "recharts";
import '../../../styles/common/00-settings/variables.scss'
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface AttendanceChartProps {
    activeEmployee?: number;
    present?: number;
    absent?: number;
    onLeave?: number;
    loading: boolean;
}

const AttendanceChart: React.FC<AttendanceChartProps> = (props) => {


    const PIE_COLORS = [
        'var(--pn-chart-secondary)',
        'var(--pn-chart-quaternary)',
        'var(  --pn-chart-primary)'
    ];

    const chartData = useMemo(() => {
        return [
            {
                name: "Present",
                value: props.present,
            },
            {
                name: "Absent",
                value: props.absent,
            },
            {
                name: "On Leave",
                value: props.onLeave,
            },
        ];
    }, [
        props.present,
        props.absent,
        props.onLeave
    ]);



    return (
        <div className={"dashboard-admin-attendance-card-chart"} >
            <LoadingSkeleton loading={props.loading}>
                <section>
                    <ResponsiveContainer width="100%" height={200}>
                        <PieChart>
                            <Pie
                                data={chartData}
                                cx="50%"
                                cy="50%"
                                innerRadius={55}
                                outerRadius={80}
                                paddingAngle={3}
                                dataKey="value"
                                nameKey="name"
                                stroke="none"
                            >
                                {chartData.map((_, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={PIE_COLORS[index % PIE_COLORS.length]}
                                        stroke="none"
                                    />
                                ))}
                            </Pie>

                            <Tooltip
                                contentStyle={{
                                    background: '#FFFFFF',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '8px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#0f172a',
                                }}
                            />

                            <Legend
                                layout="vertical"
                                verticalAlign="middle"
                                align="right"
                                iconType="circle"
                                iconSize={10}
                                formatter={(value, entry: any) => {
                                    return (
                                        <span
                                            style={{
                                                color: 'var(--pn-text-primary)',
                                                fontSize: '13px',
                                                fontWeight: 500,
                                            }}
                                        >
                {value} : {entry.payload.value}
            </span>
                                    );
                                }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </section>
            </LoadingSkeleton>

        </div>
    );
};

export default AttendanceChart;
